<template>
  <l-map :zoom="13" :center="centerPoint" style="z-index: 0;">
    <l-tile-layer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
    <!-- <l-tile-layer url="https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png"></l-tile-layer> -->
    <l-marker v-for="point in points" :lat-lng="[point.lat, point.long]" :key="point.id">
      <l-tooltip>{{ point.name }}</l-tooltip>
    </l-marker>
    <l-polyline :lat-lngs="lines" :color="color" />
    <l-geo-json v-if="geoPoints != null > 1" :geojson="geoPoints" :style="lineStyle" />
  </l-map>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LGeoJson,
  LPolyline
} from "vue2-leaflet";

export default {
  name: "RouteMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LGeoJson,
    LPolyline
  },
  computed: {
    centerPoint() {
      return this.$store.getters.centerPoint;
    },
    points() {
      return this.$store.getters.points;
    },
    lines() {
      let points = [];
      this.$store.getters.points.forEach(point => {
        points.push([point.lat, point.long]);
      });
      return points;
    },
    geoPoints() {
      return this.$store.getters.geoPoints;
    }
  },
  data: () => ({
    radius: 6,
    color: "#336633",
    fillColor: "#000000",
    fillOpacity: 0.85,
    lineStyle: {
      color: "#CCCCCC",
      weight: 1,
      opacity: 0.5
    },
    meshHeders: [],
    meshData: []
  })
};
</script>